import { Box, Button, Paper, TextField } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import { useState } from "react";
import { useNavigate } from "react-router-dom";

export const SearchBox = () => {
  const [searchText, setSearchText] = useState("");
  const [error, setError] = useState(false);
  const navigate = useNavigate();

  const onClick = async () => {
    if (searchText == null || searchText.trim() === "") {
      setError(true);
      return;
    }
    setError(false);
    const newPath = `/search/${searchText}`;
    navigate(newPath);
  };

  const handleKeyDown = (event: any) => {
    if (event.keyCode === 13) {
      event.preventDefault();
      onClick();
    }
  };

  const onSearchTextChanged = async (value: string) => {
    setSearchText(value);
    if (error) {
      setError(false);
    }
  };

  return (
    <Paper elevation={0} style={{ padding: 20 }}>
      <Box
        component="form"
        noValidate
        autoComplete="off"
        style={{ display: "flex", gap: 16 }}
      >
        <TextField
          id="outlined-basic"
          label="Search Company or Officer"
          variant="outlined"
          fullWidth
          error={error}
          helperText={error ? "Enter a company name, number, or officer name" : " "}
          onKeyDown={handleKeyDown}
          onChange={(event) => {
            onSearchTextChanged(event.target.value);
          }}
        />
        <Button
          variant="contained"
          onClick={onClick}
          aria-label="Search"
          style={{ height: 56, minWidth: 56, padding: 0 }}
        >
          <SearchIcon />
        </Button>
      </Box>
    </Paper>
  );
};

export default SearchBox;
